import SubmitForAnalysis from './SubmitForAnalysis';

export default SubmitForAnalysis;
